import { type PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface IGlobalState {
  asideShow: boolean
  lessonsNavShow: boolean
  showCalendar: boolean
}

const initialState: IGlobalState = {
  asideShow: false,
  lessonsNavShow: false,
  showCalendar: false,
}

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    asideToggleShow: (state) => {
      state.asideShow = !state.asideShow
    },
    setLessonsNavShow: (state, action: PayloadAction<boolean>) => {
      state.lessonsNavShow = action.payload
    },
    setShowCalendarOnMobile: (state) => {
      state.showCalendar = !state.showCalendar
    },
  },
})

export const globalActions = globalSlice.actions

export const globalReducer = globalSlice.reducer
